<template>
  <div>
    <h1>修改班次表</h1>
    <el-form label-width="120px" @submit.native.prevent="saveEditGrade">
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" placeholder="网校" @change="getPrice">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          multiple
          placeholder="一级分类"
          @change="getCourse"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          multiple
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="三级分类">
        <el-select
          @change="getPrice"
          v-model="model.clID"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in clclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班次年份">
        <el-input v-model="model.grYear"></el-input>
      </el-form-item>
      <el-form-item label="班次名称">
        <el-input v-model="model.grName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="grID">
        <el-input v-model="model.grID"></el-input>
      </el-form-item> -->
      <el-form-item label="班次价格">
        <el-input v-model="model.grPrice"></el-input>
      </el-form-item>
      <el-form-item label="班次价格">
        <el-input v-model="model.salePrice"></el-input>
      </el-form-item>
      <el-form-item label="选择视频课程">
        <el-select v-model="model.prVideoName" multiple placeholder="视频课程">
          <el-option
            v-for="item in prvideo"
            :key="item.index"
            :label="item.prVideoName"
            :value="item.prVideoName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择电子资料">
        <el-select v-model="model.prPdfName" multiple placeholder="电子资料">
          <el-option
            v-for="item in prpdf"
            :key="item.prPdfId"
            :label="item.prPdfName"
            :value="item.prPdfName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择教学服务">
        <el-select
          v-model="model.prServiceName"
          multiple
          placeholder="教学服务"
        >
          <el-option
            v-for="item in prservice"
            :key="item.prServiceId"
            :label="item.prServiceName"
            :value="item.prServiceName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择听课方式">
        <el-select v-model="model.prTeachWayName" placeholder="听课方式">
          <el-option
            v-for="item in prteachway"
            :key="item.prTeachWayId"
            :label="item.prTeachWayName"
            :value="item.prTeachWayName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择学习期限">
        <el-select v-model="model.prTeachTimeName" placeholder="学习期限">
          <el-option
            v-for="item in prteachtime"
            :key="item.prTeachTimeId"
            :label="item.prTeachTimeName"
            :value="item.prTeachTimeName"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      clclass: [],
      getgrade: [],
      grade: {},
      model: {
        grName: "",
        grPrice: "",
        grYear: "",
        salePrice: "",
      },
      prpdf: [],
      prservice: {},
      prvideo: {},
      prteachway: {},
      prteachtime: {},
      maID: "",
      chID: "",
      coID: "",
      clID: "",
      grName: "",
      grPrice: "",
      grYear: "",
    };
  },
  methods: {
    async saveEditGrade() {
      try {
        const putgrade = await this.$http.put(
          "/category/putgrade?_id=" + `${this.id}`,
          this.model
        );
        //this.$router.push("/categories/list");
        if (putgrade.status === 201) {
          this.$message({
            type: "success",
            message: putgrade.data.msg,
          });
          this.$router.push("/grade/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;

        this.getPrice(chID);
      } catch (error) {
        console.log(error);
      }
      //if (chID) this.chID = chID[0];
    },
    /* async getMaId(maID) {
      //this.maID = maID;
      this.getGrade(maID);
    }, */
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.clclass = getclass.data;
        this.getPrice(coID);
      } catch (error) {
        console.log(error);
      }
      //if (coID) this.coID = coID[0];
    },
    async getPrice() {
      try {
        let params = {
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
        };
        //console.log(params);
        const getprice = await this.$http.get("/category/getprice", {
          params,
        });
        //console.log(getprice.data[0].result[0]);
        this.prpdf = getprice.data[0].result[0].prpdf;
        this.prservice = getprice.data[0].result[0].prservice;

        this.prvideo = getprice.data[0].result[0].prvideo;
        this.prteachway = getprice.data[0].result[0].prteachway;
        this.prteachtime = getprice.data[0].result[0].prteachtime;
      } catch (error) {
        console.log(error);
      }
    },
    async getGrade() {
      try {
        const getGrade = await this.$http.get("/category/getgrade");
        this.getgrade = getGrade.data;
        //console.log(this.getgrade);
      } catch (error) {
        console.log(error);
      }
    },

    //编辑修改grade
    async getEditGrade() {
      try {
        const editgrade = await this.$http.get("/category/editgrade", {
          params: { id: this.id },
        });
        //console.log(editgrade.data[0].course.find((item) => item.oid === 2));
        this.model.maID = editgrade.data[0].maID;
        this.model.chID = editgrade.data[0].chID;
        this.model.coID = editgrade.data[0].coID;
        this.model.clID = editgrade.data[0].clID;
        this.model.grName = editgrade.data[0].grName;
        this.model.grPrice = editgrade.data[0].grPrice;
        this.model.grYear = editgrade.data[0].grYear;
        this.model.salePrice = editgrade.data[0].salePrice;
        this.model.salePrice = editgrade.data[0].salePrice;
        //this.prvideo = editgrade.data[0].prVideoName;
        /*this.prpdf = editgrade.data[0].prpdf;
      this.prservice = editgrade.data[0].prservice;
      this.prteachway = editgrade.data[0].prteachway;
      this.prteachtime = editgrade.data[0].prteachtime; */
        //this.price = EditPrice.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getGrade();
    this.id && this.getEditGrade(this.id);
    //this.gradeDelete();
  },
};
</script>
